export default "__VITE_ASSET__$HJ9RCtG__"